import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link, withRouter } from 'react-router-dom';

import Select from 'react-select';

import logo from './assets/images/logos/Icon@2x.png';
import newLogo from './assets/images/logos/New-Logo-Color@2x.png';

import {
  getIcon,
  getCookie,
  setCookie,
  deleteCookie,
  isLocalhost,
} from './util';

class SiteMovedMessage extends Component{

  state = {
    automaticallyRedirectOnDevice: false,
  }

  componentDidMount(){
    if(getCookie('velocity_v0_redirect_to_new_app_url') === 'YES'){

      //won't actually be a different url, so don't redirect
      if(isLocalhost()){
        return;
      }

      let newVersionOfCurrentUrl = `` + document.location;
      newVersionOfCurrentUrl = newVersionOfCurrentUrl.replace('velocitytalent','auctusiq');

      //redirect to new version of url
      document.location = newVersionOfCurrentUrl;

      this.setState({
        automaticallyRedirectOnDevice: true
      });
    }
  }

  enableAutomaticRedirecting(){
    this.setState({
      automaticallyRedirectOnDevice: true
    });

    setCookie('velocity_v0_redirect_to_new_app_url', 'YES');
  }
  disableAutomaticRedirecting(){
    this.setState({
      automaticallyRedirectOnDevice: false
    });

    deleteCookie('velocity_v0_redirect_to_new_app_url');
  }

  render(){

    const newSiteIsLive = true;

    let newVersionOfCurrentUrl = `` + document.location;
    newVersionOfCurrentUrl = newVersionOfCurrentUrl.replace('velocitytalent','auctusiq');

    return (
      <div className="modal site-moved">
        <div className="modal-container">
          {!newSiteIsLive &&
            <div className="modal-content">
              <div className="icon-changes">
                <img className="old-icon" src={logo} />
                <div className="arrow">{getIcon('arrow-right')}</div>
                <img className="new-icon" src={newLogo} />
              </div>
              <div className="message">
                <h3>This version of the Velocity App is currently unavailable as we migrate all user accounts & data to our new domain: auctusiq.com. We expected this process to be completed on December 29, 2019.</h3>
                <p><small>Once the new site is live, this page will provide a link you can use to continue to the new site.</small></p>
              </div>
            </div>
          }
          {newSiteIsLive &&
            <React.Fragment>
              <div className="modal-content">
                <div className="icon-changes">
                  <img className="old-icon" src={logo} />
                  <div className="arrow">{getIcon('arrow-right')}</div>
                  <img className="new-icon" src={newLogo} />
                </div>
                <div className="message">
                  <h2>The Velocity App has moved domains...</h2>
                  <p>We have rebranded our company from Velocity to AuctusIQ, and as such, the application will now be hosted at auctusiq.com. Click "Continue to App" below to continue to this page in the new app!</p>
                  <p style={{lineHeight: 1.25}}><small>All user accounts & data have been migrated to the new site.</small></p>
                </div>
              </div>
              <div className="modal-actions">
                <a href={newVersionOfCurrentUrl}><button className={`button blue-button`}>Continue to App</button></a>
                <div className={`automatically-redirect-option-container ${this.state.automaticallyRedirectOnDevice ? 'active' : ''}`}><input onChange={event => { if(event.target.checked){ this.enableAutomaticRedirecting() }else{ this.disableAutomaticRedirecting() } }} checked={this.state.automaticallyRedirectOnDevice} id="automatically-redirect-option" type="checkbox" /><label for="automatically-redirect-option">Automatically redirect me to new site on this device</label></div>
              </div>
            </React.Fragment>
          }
        </div>
      </div>
    )
  }
}

export default SiteMovedMessage;



// WEBPACK FOOTER //
// ./src/siteMoved.js